const MisLaboratoriosIcon = ({ color }) => {
  return (
    <svg
      width="17"
      height="26"
      viewBox="0 0 17 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7143 6H2.28571C1.57563 6 1 6.57563 1 7.28571V23.7143C1 24.4244 1.57563 25 2.28571 25H14.7143C15.4244 25 16 24.4244 16 23.7143V7.28571C16 6.57563 15.4244 6 14.7143 6Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6233 3.01477C11.6233 3.09791 11.6199 3.18027 11.6133 3.26172H12.5434C13.3718 3.26172 14.0434 3.93329 14.0434 4.76172V6.10954C14.0434 6.93797 13.3718 7.60954 12.5434 7.60954H4.67383C3.8454 7.60954 3.17383 6.93797 3.17383 6.10954V4.76172C3.17383 3.93329 3.8454 3.26172 4.67383 3.26172H5.60372C5.59712 3.18027 5.59375 3.09791 5.59375 3.01477C5.59375 1.34976 6.94351 0 8.60852 0C10.2735 0 11.6233 1.34976 11.6233 3.01477ZM8.60939 4.30652C9.4419 4.30652 10.1168 3.63164 10.1168 2.79913C10.1168 1.96663 9.4419 1.29175 8.60939 1.29175C7.77689 1.29175 7.10201 1.96663 7.10201 2.79913C7.10201 3.63164 7.77689 4.30652 8.60939 4.30652Z"
        fill={color}
      />
      <path
        d="M9.8625 14.0375V14.1375H9.9625H12.6062C12.7862 14.1375 12.9 14.2711 12.9 14.375V16.6124C12.874 16.7116 12.8381 16.7882 12.7921 16.8394C12.7475 16.8889 12.69 16.9188 12.6062 16.9188H9.9625H9.8625V17.0188V19.6625C9.8625 19.7479 9.83148 19.8045 9.79059 19.8409C9.74787 19.8789 9.68807 19.9 9.625 19.9H7.375C7.27775 19.9 7.20374 19.8756 7.15622 19.8375C7.1117 19.8019 7.08125 19.7474 7.08125 19.6625V17.0188V16.9188H6.98125H4.3375C4.25263 16.9188 4.19808 16.8883 4.16246 16.8438C4.12444 16.7963 4.1 16.7222 4.1 16.625V14.375C4.1 14.3119 4.12114 14.2521 4.15912 14.2094C4.19546 14.1685 4.25214 14.1375 4.3375 14.1375H6.98125H7.08125V14.0375V11.3937C7.08125 11.224 7.20523 11.1 7.375 11.1H9.625C9.72887 11.1 9.8625 11.2138 9.8625 11.3937V14.0375Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default MisLaboratoriosIcon;
